import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SmallOrderTeamComponent } from './small-order-team.component';

const routes: Routes = [
  {
    path: '',
    component: SmallOrderTeamComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmallOrderTeamRoutingModule { }
